import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * A funnel block asks the page that owns the footer button to run the same
 * continue action, including the last step that leaves for payment.
 */
@Injectable({ providedIn: 'root' })
export class CartFunnelContinueService {
  private readonly requests = new Subject<void>();
  readonly requests$ = this.requests.asObservable();

  request(): void {
    this.requests.next();
  }
}
